import { render, staticRenderFns } from "./myhome.vue?vue&type=template&id=670101fc&scoped=true&"
import script from "./myhome.vue?vue&type=script&lang=js&"
export * from "./myhome.vue?vue&type=script&lang=js&"
import style0 from "./myhome.vue?vue&type=style&index=0&id=670101fc&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "670101fc",
  null
  
)

export default component.exports